module.exports = __webpack_public_path__ + "static/media/denys.87fc3b1a.jpg";